import React, { useState } from 'react';
import InfoButton from './InfoButton';

const InfoTooltip = props => {
  const [display, setDisplay] = useState('none');

  const showTooltip = () => {
    setDisplay('flex');
  };

  const hideTooltip = () => {
    setDisplay('none');
  };

  return (
    <button type="button" onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
      <div className="tooltip" style={{ display: display }}>
        {props.text}
      </div>
      <InfoButton />
      <style jsx>{`
        button {
          background-color: transparent;
          border: 0;
          cursor: pointer;
          padding: 0;
          position: relative;
        }

        .tooltip {
          position: absolute;
          width: 200px;
          min-height: 10px;
          background-color: #56504c;
          color: white;
          border-radius: 4px;
          left: 50%;
          padding: 8px 12px;
          font-size: 12px;
          line-height: 18px;
          text-align: left;
          transform: translate(-50%, -118%);
        }

        .tooltip::after {
          content: '';
          width: 0;
          height: 0;
          border-right: 10px solid transparent;
          border-top: 10px solid transparent;
          border-left: 10px solid transparent;
          border-bottom: 8px solid #56504c;
          top: 99%;
          left: 50%;
          transform: translateX(-50%) rotate(180deg);
          position: absolute;
        }
      `}</style>
    </button>
  );
};

export default InfoTooltip;
